export function isForceHttpsEnabled() {
  return process.env.REACT_APP_FORCE_HTTPS === 'true';
}

export function ensureProductionHttps() {
  if (!isForceHttpsEnabled()) return;
  if (typeof window === 'undefined') return;
  if (window.location.protocol !== 'http:') return;

  window.location.replace(
    `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
}
